import { render } from "./Navi.vue?vue&type=template&id=8339537a&scoped=true"
import script from "./Navi.vue?vue&type=script&lang=js"
export * from "./Navi.vue?vue&type=script&lang=js"

import "./Navi.vue?vue&type=style&index=0&id=8339537a&scoped=true&lang=css"

import exportComponent from "D:\\sycode\\ijj-web\\iseso-mall-pc-vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8339537a"]])

export default __exports__